import FullSite from "./full-site";
import { LiveEventLayout } from "../../jamibet/desktop-pages/live-event";

export default function LiveEvent(props) {
	return <FullSite><LiveEventLayout {...props} /></FullSite>;
}
